import React from 'react';
import { benefits, bonuses } from '../data/content';
export function BonusSection() {
  return <>
      <section className="bg-brand-cream px-4 py-5 sm:px-6" aria-labelledby="bonus-heading" data-id="element-16" data-mp="1ogn81qbidt6h">
        <div className="mb-3 text-center" data-id="element-17" data-mp="22fwpetbgatc1">
          <h2 id="bonus-heading" className="mb-1 text-xl font-extrabold uppercase leading-tight text-brand-navy sm:text-3xl" data-id="element-18" data-mp="22etwygyhciu0">
            🎁 5 Premium Bonuses Included
          </h2>
          <p className="text-[12px] font-medium leading-snug text-brand-ink sm:text-sm" data-id="element-19" data-mp="1am2ydztbqi1l">
            Your access also includes five professional bonuses designed to help you coach more
            efficiently, analyze performance, organize groups, and prepare players for competition.
          </p>
        </div>
        <div className="space-y-2" data-id="element-20" data-mp="r0gc7kz0wji7">
          {bonuses.map((bonus, index) => <article key={bonus.title} className="rounded-lg border border-brand-teal/50 bg-white p-3 text-center shadow-sm" data-id="element-21" data-mp="qy3o0q2o9cwp" data-mpi={index}>
              <h3 className="mb-0.5 text-[12px] font-extrabold leading-tight text-brand-navy sm:text-sm" data-id="element-22" data-mp="29rjv2rsfyjbe">
                <span className="text-brand-teal" data-id="element-23" data-mp="2epla91mqxyhl">🎁 BONUS {index + 1} — </span>
                {bonus.title}
              </h3>
              <p className="text-[11px] font-medium leading-snug text-brand-ink/80 sm:text-xs" data-id="element-24" data-mp="2jk8u2n6t24pu">
                {bonus.description}
              </p>
            </article>)}
        </div>
      </section>
      <section className="bg-white px-4 py-5 sm:px-6" aria-labelledby="change-heading" data-id="element-25" data-mp="1vsbp9g1rwcy8">
        <h2 id="change-heading" className="mb-3 text-center text-xl font-extrabold uppercase leading-tight text-brand-navy sm:text-3xl" data-id="element-26" data-mp="1vu4yn33rtb9x">
          What Will Change
        </h2>
        <div className="space-y-2" data-id="element-27" data-mp="3c6k2ul4kfbxq">
          {benefits.map(benefit => <article key={benefit.title} className="flex gap-2.5 rounded-lg border-l-4 border-brand-teal bg-brand-cream p-3 shadow-sm" data-id="element-28" data-mp="3c8o40vb2xwub">
              <span className="text-lg leading-none" aria-hidden="true" data-id="element-29" data-mp="1h1u7hyi8po79">
                {benefit.emoji}
              </span>
              <div data-id="element-30" data-mp="1c6olkzou89j6">
                <h3 className="mb-0.5 text-[12px] font-extrabold leading-tight text-brand-navy sm:text-sm" data-id="element-31" data-mp="1q3tpat12wwb9">
                  {benefit.title}
                </h3>
                <p className="text-[11px] font-medium leading-snug text-brand-ink/80 sm:text-xs" data-id="element-32" data-mp="1m39p1gl7lckw">
                  {benefit.description}
                </p>
              </div>
            </article>)}
        </div>
      </section>
    </>;
}